export default "__VITE_ASSET__Cyy4kMf7__"